import React from 'react';

export default class ResultTitle extends React.Component {
    constructor(props) {
        super(props)
    }
    componentDidMount() {

    }

    render() {
        let stateRes = this.props.data
        let totalseats = (stateRes['totalSeats'] + "").length >= 2 ? stateRes['totalSeats'] : '0' + stateRes['totalSeats'];
        let countedseats = (stateRes['countedSeats'] + "").length >= 2 ? stateRes['countedSeats'] : '0' + stateRes['countedSeats'];
        if (this.props.countedSeats) {

            countedseats = this.props.countedSeats
            countedseats = (countedseats + "").length >= 2 ? countedseats : '0' + countedseats;
        }
        return (<h4 className="election_result_title" key={Math.random()}>{stateRes['name']} {"(" + countedseats + "/" + totalseats + ")"}</h4>)
    }
}